import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import { get, post } from '../Services/http';
import { catchError } from './Error.action';
import {
    ORGANIZATION_SEARCH_QUERY,
    ORGANIZATION_SEARCH_RECEIVE,
    ORGANIZATION_SEARCH_ERROR, ORGANIZATION_TOGGLE_RESULT,
} from '../constants';

let abortController;

export const query = () => (dispatch, getState) => {
    // abort any existing, pending request.
    // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
    abortController && abortController.abort();
    abortController = new AbortController();
    return get('/api/organizationsearch', abortController)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => searchError(error))));
};

export const selectOrganization =
    (selectedOrganization, redirectUrl) => dispatch => {
        return post('/api/organizationsearch/selectorganization?selectedOrganization=' + selectedOrganization)
            .then(() => {
                window.location = redirectUrl;
            })
            .catch(ex => dispatch(catchError(ex, error => searchError(error))));
    };

export const setSearchQuery = query => ({
    type: ORGANIZATION_SEARCH_QUERY,
    payload: {
        query,
    },
});

export const searchError = error => ({
    type: ORGANIZATION_SEARCH_ERROR,
    payload: {
        error,
    },
});

export const receive = result => ({
    type: ORGANIZATION_SEARCH_RECEIVE,
    payload: {
        result
    },
});

export const doShowResult = showResult => ({
    type: ORGANIZATION_TOGGLE_RESULT,
    payload: {
        showResult: showResult,
    },
});
